import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-play",
  "use": "icon-icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-play\"><path d=\"M292.571 73.143a73.143 73.143 0 0 1 73.143 73.143v731.428a73.143 73.143 0 0 1-146.285 0V146.286a73.143 73.143 0 0 1 73.142-73.143zm438.858 0a73.143 73.143 0 0 1 73.142 73.143v731.428a73.143 73.143 0 0 1-146.285 0V146.286a73.143 73.143 0 0 1 73.143-73.143z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol